import React from 'react';
import { Box, MobileDrawer, Popover } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import CertsConsultContent from './CertsConsultContent';

import './CertsConsultPopover.css';

function CertsConsultPopover({
  isMobileXlargeWidth,
  isCommentPopoverOpen,
  setIsCommentPopoverOpen,
  placement,
  trigger,
  onSubmit,
}) {
  return (
    <Box tag='div' className='CertsConsultPopover-contextWrapper'>
      {isMobileXlargeWidth ? (
        <>
          {trigger}
          <MobileDrawer
            isOpen={isCommentPopoverOpen}
            setIsOpen={setIsCommentPopoverOpen}
            isSwipeEnabled
            content={
              <CertsConsultContent
                isMobileXlargeWidth={isMobileXlargeWidth}
                onSubmit={onSubmit}
                setIsCommentPopoverOpen={setIsCommentPopoverOpen}
              />
            }
            className='CertsConsultPopover'
          />
        </>
      ) : (
        <Popover
          isPortalEnabled
          placement={placement}
          trigger={trigger}
          popoverContent={
            <CertsConsultContent
              isMobileXlargeWidth={isMobileXlargeWidth}
              onSubmit={onSubmit}
              setIsCommentPopoverOpen={setIsCommentPopoverOpen}
            />
          }
          isOpen={isCommentPopoverOpen}
          setIsOpen={setIsCommentPopoverOpen}
        />
      )}
    </Box>
  );
}

CertsConsultPopover.defaultProps = {};

CertsConsultPopover.propTypes = {
  isCommentPopoverOpen: PropTypes.bool.isRequired,
  setIsCommentPopoverOpen: PropTypes.func.isRequired,
  placement: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isMobileXlargeWidth: PropTypes.bool.isRequired,
};

export default CertsConsultPopover;
